import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
// --- Custom Bespoke SVG Illustrations for Extras ---
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1283">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1284" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-1285" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-1286" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-1287" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-1288" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-1289" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1290">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-1291" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-1292" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-1293" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-1294" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-1295" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-1296" />
  </svg>;
const OvenIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1297">
    <rect x="12" y="14" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1298" />
    <rect x="16" y="18" width="32" height="10" rx="2" fill="#2BBCB3" data-id="element-1299" />
    <rect x="16" y="32" width="32" height="18" rx="2" fill="#E8F6F5" data-id="element-1300" />
    <rect x="22" y="36" width="20" height="10" rx="1" fill="#1B1B2F" data-id="element-1301" />
    <circle cx="20" cy="23" r="2" fill="#1B1B2F" data-id="element-1302" />
    <circle cx="28" cy="23" r="2" fill="#1B1B2F" data-id="element-1303" />
    <circle cx="36" cy="23" r="2" fill="#1B1B2F" data-id="element-1304" />
    <circle cx="44" cy="23" r="2" fill="#1B1B2F" data-id="element-1305" />
  </svg>;
const FridgeIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1306">
    <rect x="16" y="8" width="32" height="48" rx="4" fill="#1B1B2F" data-id="element-1307" />
    <rect x="20" y="12" width="24" height="16" rx="2" fill="#2BBCB3" data-id="element-1308" />
    <rect x="20" y="30" width="24" height="22" rx="2" fill="#E8F6F5" data-id="element-1309" />
    <rect x="24" y="16" width="2" height="8" fill="#1B1B2F" data-id="element-1310" />
    <rect x="24" y="34" width="2" height="12" fill="#1B1B2F" data-id="element-1311" />
  </svg>;
const MicrowaveIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1312">
    <rect x="10" y="20" width="44" height="24" rx="4" fill="#1B1B2F" data-id="element-1313" />
    <rect x="14" y="24" width="24" height="16" rx="2" fill="#E8F6F5" data-id="element-1314" />
    <rect x="42" y="24" width="8" height="16" rx="2" fill="#2BBCB3" data-id="element-1315" />
    <rect x="44" y="26" width="4" height="2" fill="#1B1B2F" data-id="element-1316" />
    <rect x="44" y="30" width="4" height="2" fill="#1B1B2F" data-id="element-1317" />
    <rect x="44" y="34" width="4" height="2" fill="#1B1B2F" data-id="element-1318" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1319">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-1320" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1321" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1322" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1323" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1324" />
  </svg>;
const ConservatoryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1325">
    <path d="M12 32 L32 16 L52 32" stroke="#1B1B2F" strokeWidth="3" fill="none" data-id="element-1326" />
    <rect x="14" y="32" width="36" height="20" rx="2" fill="#1B1B2F" data-id="element-1327" />
    <rect x="18" y="34" width="12" height="16" rx="1" fill="#E8F6F5" data-id="element-1328" />
    <rect x="34" y="34" width="12" height="16" rx="1" fill="#E8F6F5" data-id="element-1329" />
    <line x1="24" y1="34" x2="24" y2="50" stroke="#2BBCB3" strokeWidth="1.5" data-id="element-1330" />
    <line x1="40" y1="34" x2="40" y2="50" stroke="#2BBCB3" strokeWidth="1.5" data-id="element-1331" />
    <line x1="18" y1="42" x2="30" y2="42" stroke="#2BBCB3" strokeWidth="1.5" data-id="element-1332" />
    <line x1="34" y1="42" x2="46" y2="42" stroke="#2BBCB3" strokeWidth="1.5" data-id="element-1333" />
    <circle cx="32" cy="12" r="4" fill="#F5C842" data-id="element-1334" />
  </svg>;
const FluBusterIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1335">
    <path d="M32 12 C42 12 50 20 50 32 C50 48 32 56 32 56 C32 56 14 48 14 32 C14 20 22 12 32 12 Z" fill="#2BBCB3" data-id="element-1336" />
    <path d="M32 20 L32 44 M20 32 L44 32" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" data-id="element-1337" />
    <circle cx="44" cy="20" r="4" fill="#E85D4A" data-id="element-1338" />
    <circle cx="20" cy="44" r="3" fill="#F5C842" data-id="element-1339" />
  </svg>;
const BaseboardsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1340">
    <rect x="12" y="12" width="40" height="32" fill="#E8F6F5" data-id="element-1341" />
    <rect x="12" y="44" width="40" height="8" fill="#1B1B2F" data-id="element-1342" />
    <path d="M24 36 Q32 28 40 36" stroke="#2BBCB3" strokeWidth="4" strokeLinecap="round" data-id="element-1343" />
    <circle cx="40" cy="36" r="4" fill="#F5C842" data-id="element-1344" />
  </svg>;
const WindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1345">
    <rect x="16" y="12" width="32" height="40" rx="2" fill="#1B1B2F" data-id="element-1346" />
    <rect x="20" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1347" />
    <rect x="34" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1348" />
    <rect x="20" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1349" />
    <rect x="34" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1350" />
    <path d="M20 16 L30 32 M34 16 L44 32" stroke="#2BBCB3" strokeWidth="2" strokeOpacity="0.5" data-id="element-1351" />
  </svg>;
const BlindsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1352">
    <rect x="16" y="12" width="32" height="6" rx="1" fill="#1B1B2F" data-id="element-1353" />
    <rect x="18" y="22" width="28" height="4" fill="#2BBCB3" data-id="element-1354" />
    <rect x="18" y="30" width="28" height="4" fill="#2BBCB3" data-id="element-1355" />
    <rect x="18" y="38" width="28" height="4" fill="#2BBCB3" data-id="element-1356" />
    <rect x="18" y="46" width="28" height="4" fill="#2BBCB3" data-id="element-1357" />
    <rect x="42" y="18" width="2" height="36" fill="#1B1B2F" data-id="element-1358" />
    <circle cx="43" cy="54" r="3" fill="#E85D4A" data-id="element-1359" />
  </svg>;
const SheetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1360">
    <rect x="12" y="24" width="40" height="20" rx="4" fill="#1B1B2F" data-id="element-1361" />
    <rect x="16" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-1362" />
    <rect x="34" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-1363" />
    <path d="M12 34 L52 34 L52 44 L12 44 Z" fill="#2BBCB3" data-id="element-1364" />
    <path d="M12 34 Q32 24 52 34" fill="#E8F6F5" data-id="element-1365" />
    <rect x="16" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-1366" />
    <rect x="44" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-1367" />
  </svg>;
const PropertyCleanupIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1368">
    <path d="M32 12 L12 28 L16 28 L16 48 L48 48 L48 28 L52 28 Z" fill="#1B1B2F" data-id="element-1369" />
    <rect x="28" y="36" width="8" height="12" fill="#E8F6F5" data-id="element-1370" />
    <path d="M40 32 L46 20 L48 22 L42 34 Z" fill="#F5C842" data-id="element-1371" />
    <circle cx="46" cy="20" r="3" fill="#2BBCB3" data-id="element-1372" />
    <path d="M18 48 L26 40 L30 48 Z" fill="#E85D4A" data-id="element-1373" />
  </svg>;
const PatioIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1374">
    <rect x="12" y="40" width="40" height="8" rx="2" fill="#1B1B2F" data-id="element-1375" />
    <rect x="16" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-1376" />
    <rect x="28" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-1377" />
    <rect x="44" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-1378" />
    <rect x="12" y="20" width="40" height="4" rx="1" fill="#1B1B2F" data-id="element-1379" />
    <circle cx="32" cy="14" r="6" fill="#F5C842" data-id="element-1380" />
    <path d="M26 14 Q32 8 38 14" stroke="#E85D4A" strokeWidth="2" fill="none" data-id="element-1381" />
  </svg>;
// --- Main Component ---
export function HomeCleaningForm() {
  // Step 3 State
  const [parking, setParking] = useState('Free on street');
  const [lastCleaning, setLastCleaning] = useState('< 1 month');
  const [pets, setPets] = useState('None');
  const [useSupplies, setUseSupplies] = useState('Yes');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'dishwasher',
    label: 'Loading/unloading dishwasher',
    icon: DishwasherIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'oven',
    label: 'Inside of oven',
    icon: OvenIcon
  }, {
    id: 'fridge',
    label: 'Inside of fridge',
    icon: FridgeIcon
  }, {
    id: 'microwave',
    label: 'Inside microwave',
    icon: MicrowaveIcon
  }, {
    id: 'cabinets',
    label: 'Interior & Exterior of Kitchen Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'conservatory',
    label: 'Conservatory',
    icon: ConservatoryIcon
  }, {
    id: 'flu',
    label: 'Flu Buster - Eucalyptus',
    icon: FluBusterIcon
  }, {
    id: 'baseboards',
    label: 'Hand Wipe Baseboards',
    icon: BaseboardsIcon
  }, {
    id: 'windows',
    label: 'Interior Windows',
    icon: WindowsIcon
  }, {
    id: 'blinds',
    label: 'Wet Wipe Blinds',
    icon: BlindsIcon
  }, {
    id: 'sheets',
    label: 'Change Sheets',
    icon: SheetsIcon
  }, {
    id: 'property',
    label: 'Property Cleanup',
    icon: PropertyCleanupIcon
  }, {
    id: 'patio',
    label: 'Patio or Balcony',
    icon: PatioIcon
  }];
  // Step 5 State
  const [frequency, setFrequency] = useState('Every 2 Weeks');
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  // Helper for Step Headings
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-1382">
      <div className="flex items-center gap-4 mb-2" data-id="element-1383">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-1384">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1385">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-1386">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-1387"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-1388">
      <SEOHead title="Book Home Cleaning | Smith & Jengs" description="Book affordable, flexible home cleaning in Bicester. Dusting, vacuuming, mopping and more. Book online in 60 seconds." data-id="element-1389" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-1390">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-1391"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1392">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-1393">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-1394">
              Home
            </Link>
            <span className="mx-2" data-id="element-1395">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-1396">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-1397">/</span>
            <span className="text-accent" data-id="element-1398">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1399">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-1400">
              Basic Home Cleaning
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-1401">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-1402">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-1403">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-1404">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-1405">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-1406">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#2BBCB3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1407">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-1408"></path>
                  <polyline points="9 22 9 12 15 12 15 22" data-id="element-1409"></polyline>
                </svg>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-1410">
                Home Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-1411">
                It only takes 60 seconds to Book your Home Cleaning!
              </p>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-1412">
              {/* STEP 1 */}
              <section data-id="element-1413">
                <StepHeading number="1" title="Your contact information." data-id="element-1414" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1415">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1416" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1417" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1418" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-1419">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-1420">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-1421" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-1422">
                <StepHeading number="2" title="Location of the home to be cleaned." data-id="element-1423" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1424">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1425" />
                  <input type="text" placeholder="Flat/Unit Number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1426" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1427" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1428" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-1429">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-1430">
                    See what's included in our base Home Cleaning service{' '}
                    <Info size={16} data-id="element-1431" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-1432">
                <StepHeading number="3" title="Tell us about the cleaning" data-id="element-1433" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-1434">
                  <div data-id="element-1435">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1436">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1437">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1438">
                        <option data-id="element-1439">2 Hours</option>
                        <option data-id="element-1440">3 Hours</option>
                        <option data-id="element-1441">4 Hours</option>
                        <option data-id="element-1442">5 Hours</option>
                        <option data-id="element-1443">6 Hours</option>
                        <option data-id="element-1444">7 Hours</option>
                        <option data-id="element-1445">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1446">
                        <option data-id="element-1447">1 Cleaner</option>
                        <option data-id="element-1448">2 Cleaners</option>
                        <option data-id="element-1449">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1450">
                    <label className="text-primary font-medium text-lg" data-id="element-1451">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1452">
                      <option data-id="element-1453">Studio / 1 Bedroom</option>
                      <option data-id="element-1454">2 Bedrooms</option>
                      <option data-id="element-1455">3 Bedrooms</option>
                      <option data-id="element-1456">4 Bedrooms</option>
                      <option data-id="element-1457">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1458">
                    <label className="text-primary font-medium text-lg" data-id="element-1459">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1460">
                      <option data-id="element-1461">1 Bathroom</option>
                      <option data-id="element-1462">2 Bathrooms</option>
                      <option data-id="element-1463">3 Bathrooms</option>
                      <option data-id="element-1464">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1465">
                    <label className="text-primary font-medium text-lg" data-id="element-1466">
                      Additional Rooms (dining room, living room, office, etc)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1467">
                      <option data-id="element-1468">No additional rooms</option>
                      <option data-id="element-1469">1 Room</option>
                      <option data-id="element-1470">2 Rooms</option>
                      <option data-id="element-1471">3 Rooms</option>
                      <option data-id="element-1472">4+ Rooms</option>
                    </select>
                  </div>

                  <div data-id="element-1473">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1474">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1475">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid car park'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1476">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-1477">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1478">
                      When was your last full cleaning?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-md" data-id="element-1479">
                      {['< 1 month', "I'm too embarrassed to say"].map(opt => <button key={opt} type="button" onClick={() => setLastCleaning(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${lastCleaning === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1480">
                            {opt}
                          </button>)}
                    </div>
                  </div>

                  <div data-id="element-1481">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1482">
                      Do you have any pets? (Required for safety & allergy
                      reasons)
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1483">
                      {['None', 'Dog', 'Cat'].map(opt => <button key={opt} type="button" onClick={() => setPets(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${pets === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1484">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-1485">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1486">
                      All cleaning supplies are included at no extra charge.
                      Would you prefer we use yours?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-[200px]" data-id="element-1487">
                      {['Yes', 'No'].map(opt => <button key={opt} type="button" onClick={() => setUseSupplies(opt)} className={`flex-1 py-3.5 px-4 text-sm font-bold transition-all duration-300 ${useSupplies === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1488">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-1489">
                <StepHeading number="4" title="Any Extras?" subtitle="Free up more of your precious time for what matters most!" data-id="element-1490" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-1491">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-1492">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-1493">
                          <Icon data-id="element-1494" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-1495">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-1496">
                <StepHeading number="5" title="How often would you like us to clean?" subtitle="Save up to 15% on the Base Cleaning." data-id="element-1497" />
                <div className="ml-0 md:ml-14" data-id="element-1498">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1499">
                    {['One time', 'Weekly', 'Every 2 Weeks', 'Every 4 Weeks'].map(opt => <button key={opt} type="button" onClick={() => setFrequency(opt)} className={`flex-1 min-w-[120px] py-4 px-4 text-sm font-medium transition-all duration-300 ${frequency === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1500">
                        {opt}
                      </button>)}
                  </div>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-1501">
                <StepHeading number="6" title="Pick a date for the cleaning." subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-1502" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-1503">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1504">
                    <span className="font-bold text-primary mb-3" data-id="element-1505">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-1506">
                      <span className="text-gray-500 text-sm" data-id="element-1507">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-1508">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-1509"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-1510">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1511">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-1512">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1513">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1514">
                          <circle cx="12" cy="12" r="10" data-id="element-1515"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-1516"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-1517"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-1518">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-1519">
                            <span className="text-sm font-medium mb-1" data-id="element-1520">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-1521">
                              <Calendar size={12} data-id="element-1522" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1523">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1524">
                          <circle cx="12" cy="12" r="10" data-id="element-1525"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-1526"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-1527"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-1528">
                      {['14:00', '14:30', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-1529">
                          <Clock size={16} data-id="element-1530" />
                          {time}
                        </button>)}
                    </div>
                  </div>

                  <p className="text-gray-500 text-sm italic" data-id="element-1531">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>

                  <div data-id="element-1532">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1533">
                      Are there any additional details we need to know?
                    </label>
                    <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-1534"></textarea>
                  </div>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-1535">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Card charges may be pre-authorised, but applied only after the service event is complete." data-id="element-1536" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-1537">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1538">
                    {['By Cash', 'By Cheque', 'By Credit/Debit Card', 'By Bank Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1539">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-1540">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1541" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1542">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-1543">
                          <CreditCard className="text-accent" data-id="element-1544" />
                          Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-1545">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1546">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-1547" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-1548" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-1549">
                        <Lock size={14} data-id="element-1550" />
                        Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1551">
                          <polyline points="6 9 12 15 18 9" data-id="element-1552"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-1553">
                        <div className="sm:col-span-6 relative" data-id="element-1554">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1555" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-1556">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1557">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1558">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1559" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1560" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1561">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1562">
                          <option data-id="element-1563">United Kingdom</option>
                          <option data-id="element-1564">United States</option>
                          <option data-id="element-1565">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1566" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-1567">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-1568">
                        I authorise the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-1569">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-1570">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-1571">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-1572"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-1573">
                        I would like to be notified by email.
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-1574">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-1575">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-1576"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-1577">
                        I would like to be notified by text message.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-1578">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-1579">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-1580">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-1581">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-1582">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1583">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-1584">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1585">
                  <Calendar size={16} className="text-accent" data-id="element-1586" />
                  <span data-id="element-1587">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1588">
                  <Clock size={16} className="text-accent" data-id="element-1589" />
                  <span data-id="element-1590">14:00</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1591">
                  <RefreshCw size={16} className="text-accent" data-id="element-1592" />
                  <span data-id="element-1593">Every 2 Weeks</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-1594">
                <div className="flex justify-between text-gray-600" data-id="element-1595">
                  <span data-id="element-1596">Home Cleaning</span>
                  <span data-id="element-1597">£40.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1598">
                  <span data-id="element-1599">DISCOUNTS</span>
                  <span data-id="element-1600">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1601">
                  <span data-id="element-1602">EXTRAS</span>
                  <span data-id="element-1603">£0.00</span>
                </div>
              </div>

              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-1604">
                <span className="font-bold text-primary text-lg" data-id="element-1605">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-1606">£40.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}